<div class="task-table-scroll-wrapper">
    <table class="task-table">
        <colgroup>
            <col style="width: 48px" />
            <col style="min-width: 140px" />
            <col style="min-width: 160px" />
            <col style="min-width: 140px" />
            <col style="min-width: 160px" />
            <col style="min-width: 200px" />
            <col style="width: 160px" />
            <col style="width: 235px" />
        </colgroup>
        <thead>
            <tr>
                <th>
                    <span hamCheckbox [checked]="selectAllToggled" (change)="toggleCheckAll()"> </span>
                </th>
                <!-- COMPANY -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_tasks_col_mandant' | i18next }}
                        <span
                            *ngIf="activeSortBy !== TaskSortingProperties.COMPANY_NAME"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.COMPANY_NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.COMPANY_NAME && activeSortOrder === 'asc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.COMPANY_NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.COMPANY_NAME && activeSortOrder === 'desc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.COMPANY_NAME)"
                        ></span>
                    </div>
                </th>
                <!-- DUE DATE -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_due_date_table_header' | i18next }}
                        <span
                            *ngIf="activeSortBy !== TaskSortingProperties.DUE_DATE"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.DUE_DATE)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.DUE_DATE && activeSortOrder === 'asc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.DUE_DATE)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.DUE_DATE && activeSortOrder === 'desc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.DUE_DATE)"
                        ></span>
                    </div>
                </th>
                <!-- AREA / SECTION -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_section_table_header' | i18next }}
                        <span
                            *ngIf="activeSortBy !== TaskSortingProperties.SECTION_NAME"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.SECTION_NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.SECTION_NAME && activeSortOrder === 'asc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.SECTION_NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.SECTION_NAME && activeSortOrder === 'desc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.SECTION_NAME)"
                        ></span>
                    </div>
                </th>
                <!-- TASK NAME -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_task_table_header' | i18next }}
                        <span
                            *ngIf="activeSortBy !== TaskSortingProperties.TASK_NAME"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.TASK_NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.TASK_NAME && activeSortOrder === 'asc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.TASK_NAME)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.TASK_NAME && activeSortOrder === 'desc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.TASK_NAME)"
                        ></span>
                    </div>
                </th>
                <!-- LATEST COMMENT -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_latest_comment_table_header' | i18next }}
                    </div>
                </th>
                <!-- STATUS -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_status_table_header' | i18next }}
                        <span
                            *ngIf="activeSortBy !== TaskSortingProperties.TASK_STATE"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.TASK_STATE)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.TASK_STATE && activeSortOrder === 'asc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.TASK_STATE)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.TASK_STATE && activeSortOrder === 'desc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.TASK_STATE)"
                        ></span>
                    </div>
                </th>
                <!-- ASSIGNEE -->
                <th>
                    <div class="header-text-container">
                        {{ 'aumico_pm_tasks_responsible_table_header' | i18next }}
                        <span
                            *ngIf="activeSortBy !== TaskSortingProperties.ASSIGNED_TO"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.ASSIGNED_TO)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.ASSIGNED_TO && activeSortOrder === 'asc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-ascending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.ASSIGNED_TO)"
                        ></span>
                        <span
                            *ngIf="activeSortBy === TaskSortingProperties.ASSIGNED_TO && activeSortOrder === 'desc'"
                            hamIconShapes
                            icon="assets/hamIcons/chevron-sort-descending.svg"
                            [size]="'s'"
                            [keepOriginalColors]="'true'"
                            [variant]="'none'"
                            (click)="sortBy(TaskSortingProperties.ASSIGNED_TO)"
                        ></span>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let task of data"
                data-testid="tasks-row"
                (click)="onTaskClick(task.projectId, task.area, task.sectionName, task.subjectType)"
                [class.selected]="selectedTaskIds.has(task.id)"
            >
                <td (click)="onTaskCheckboxClick(task, $event)">
                    <span [checked]="selectedTaskIds.has(task.id)" hamCheckbox [bubbleEvents]="true"> </span>
                </td>

                <!-- COMPANY -->
                <td class="company-name">{{ task.companyName ?? task.personName }}</td>

                <!-- DUE DATE -->
                <td>
                    <div class="dropdown-wrapper">
                        <ham-button
                            #dueDateButtonWrapper
                            class="date-button"
                            [class.overdue]="isOverdue(task.dueDate)"
                            [class.due-soon]="isDueSoon(task.dueDate)"
                            [class.completed]="task.taskState === 100"
                            size="xs"
                            variant="white"
                            rightIcon="assets/hamIcons/calendar-month-outline.svg"
                            (click)="openDueDateFlyout(task.id, dueDateButtonWrapper)"
                            stopPropagation
                        >
                            {{ task.dueDate | dateLocale }}
                        </ham-button>
                    </div>

                    <span
                        class="menu-flyout"
                        hamFlyout
                        *ngIf="openedDueDateFlyoutTaskId === task.id"
                        [position]="flyoutPosition"
                        (closeFlyout)="closeDueDateFlyout()"
                    >
                        <div class="flyout-content">
                            <div class="custom-datepicker-wrapper">
                                <mat-calendar
                                    [selected]="calendarSelectedDate"
                                    [startAt]="calendarSelectedDate"
                                    (selectedChange)="updateDueDate(task, $event)"
                                ></mat-calendar>

                                <div class="datepicker-actions">
                                    <ham-button variant="teal" size="sm" (click)="selectToday(task)">
                                        {{ 'aumico_pm_tasks_select_date_today' | i18next }}
                                    </ham-button>
                                </div>
                            </div>
                        </div>
                    </span>
                </td>

                <!-- SECTION NAME (Bereich) -->
                <td>
                    <span class="section-badge">{{ task.sectionName }}</span>
                </td>

                <!-- TASK DESCRIPTION -->
                <td class="task-description">{{ task.description }}</td>

                <!-- LATEST COMMENT -->
                <td class="latest-comment-cell">
                    <span *ngIf="task.latestComment" class="latest-comment-truncated" [innerHTML]="formatLatestComment(task.latestComment)"></span>
                </td>

                <!-- STATUS -->
                <td>
                    <div class="dropdown-wrapper">
                        <ham-button
                            #statusButtonWrapper
                            class="status-button"
                            size="xxs"
                            variant="white"
                            (click)="openStatusFlyout(task.id, statusButtonWrapper)"
                            stopPropagation
                        >
                            <span class="inner-status-wrapper">
                                {{ getStatusLabel(task.taskState) }}
                                <span class="ham-icon">
                                    <i class="chevron-down-icon"></i>
                                </span>
                            </span>
                        </ham-button>
                    </div>

                    <span
                        class="menu-flyout"
                        hamFlyout
                        *ngIf="openedStatusFlyoutTaskId === task.id"
                        [position]="flyoutPosition"
                        (closeFlyout)="closeStatusFlyout()"
                    >
                        <div class="flyout-content">
                            <div
                                *ngFor="let status of statusOptions"
                                class="status-option"
                                [class.selected]="task.taskState === status.value"
                                (click)="updateStatus(task, status.value)"
                            >
                                {{ status.label }}
                            </div>
                        </div>
                    </span>
                </td>

                <!-- ASSIGNEE -->
                <td>
                    <div class="dropdown-wrapper assignee">
                        <ham-button
                            #assigneeButtonWrapper
                            class="assignee-button"
                            size="xs"
                            variant="white"
                            (click)="openAssigneeFlyout(task.id, assigneeButtonWrapper)"
                            stopPropagation
                        >
                            <span class="inner-assignee-wrapper">
                                <span class="avatar_and_name">
                                    <span class="avatar" [class.deleted]="task.assigneeDeleted">{{ getInitials(task.assignedTo) }}</span>
                                    <span class="name" [class.deleted]="task.assigneeDeleted">{{ task.assignedTo }}</span>
                                </span>
                                <span>
                                    <span class="ham-icon">
                                        <i class="chevron-down-icon"></i>
                                    </span>
                                </span>
                            </span>
                        </ham-button>
                    </div>

                    <span
                        class="menu-flyout"
                        hamFlyout
                        *ngIf="openedAssigneeFlyoutTaskId === task.id"
                        [position]="flyoutPosition"
                        (closeFlyout)="closeAssigneeFlyout()"
                    >
                        <div class="flyout-user-options-content">
                            <div
                                *ngFor="let assignee of assigneeOptions"
                                class="status-option assignee"
                                [class.selected]="task.assignedTo === assignee.name"
                                (click)="updateAssignee(task, assignee.id)"
                            >
                                <span class="avatar">{{ getInitials(assignee.name) }}</span>
                                <span class="name">{{ assignee.name }}</span>
                            </div>
                        </div>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="empty-state-wrapper" *ngIf="data?.length === 0">
        <div class="empty-state">
            <span
                *ngIf="!anyActiveFilter"
                class="building-wrapper"
                hamIconShapes
                icon="assets/hamIcons/closing-process.svg"
                [size]="'50px'"
            >
            </span>
            <span
                *ngIf="anyActiveFilter"
                class="building-wrapper"
                hamIconShapes
                icon="assets/hamIcons/exclamation-outline.svg"
                [size]="'50px'"
            >
            </span>

            <div class="text1" *ngIf="!anyActiveFilter">
                {{ 'tasks_empty_state_text_one' | i18next }}
            </div>

            <div class="text1" *ngIf="anyActiveFilter">
                {{ 'tasks_empty_state_text_one_filters' | i18next }}
            </div>
            <div class="text2" *ngIf="!anyActiveFilter">
                {{ 'tasks_empty_state_text_two' | i18next }}
            </div>

            <div class="text2" *ngIf="anyActiveFilter">
                {{ 'tasks_empty_state_text_two_filters' | i18next }}
            </div>
            <ham-button
                *ngIf="!anyActiveFilter"
                type="submit"
                icon="assets/hamIcons/plus-outline.svg"
                (buttonClick)="onAddProject()"
            >
                {{ 'aumico_projects_overview_add_new_project' | i18next }}
            </ham-button>
        </div>
    </div>
</div>
